import type { WhatsAppInboxMessage } from '@zrsystem/contracts';
import { type ReactElement } from 'react';

import { FormattedChatText } from '@/features/conversation/components/formatted-chat-text.js';
import { useWhatsAppInboxMediaObjectUrl } from '@/features/notification/hooks/use-whatsapp-inbox-media-object-url.js';
import { formatWhatsAppInboxTimestamp } from '@/features/notification/lib/whatsapp-inbox-timestamp.js';

export interface WhatsAppInboxVideoBubbleProps {
  readonly message: WhatsAppInboxMessage;
}

export function WhatsAppInboxVideoBubble({ message }: WhatsAppInboxVideoBubbleProps): ReactElement {
  const mediaUrl = message.media?.url ?? message.mediaUrl;
  const sourceUrl = mediaUrl !== null && mediaUrl.length > 0 ? mediaUrl : null;
  const media = useWhatsAppInboxMediaObjectUrl(sourceUrl, message.media?.mimetype ?? null);
  const caption = message.body?.trim();

  return (
    <div className="whatsapp-inbox-bubble__media">
      {media.pending ? <p>Carregando vídeo…</p> : null}
      {sourceUrl !== null && !media.pending && media.src === null ? (
        <p>Vídeo indisponível</p>
      ) : null}
      {media.src !== null ? (
        <video
          className="whatsapp-inbox-bubble__video"
          src={media.src}
          controls
          preload="metadata"
        />
      ) : null}
      {caption !== undefined && caption.length > 0 ? (
        <p>
          <FormattedChatText text={caption} />
        </p>
      ) : null}
      <time className="whatsapp-inbox-bubble__time" dateTime={String(message.timestamp)}>
        {formatWhatsAppInboxTimestamp(message.timestamp)}
      </time>
    </div>
  );
}
